import { render, staticRenderFns } from "./PostDetail.vue?vue&type=template&id=d73b10e8&"
import script from "./PostDetail.vue?vue&type=script&lang=js&"
export * from "./PostDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports